export default {
    namespaced: true,
    state: {
        openFactorAuthent2: null,
    },
    getters: {
        openFactorAuthent2: state => {
            if (state.openFactorAuthent2 === null) {
                state.openFactorAuthent2 = JSON.parse(localStorage.getItem("openFactorAuthent2"));
            }
            return state.openFactorAuthent2;
        },
    },
    mutations: {
        openFactorAuthent2(state, val) {
            state.openFactorAuthent2 = val;
            localStorage.setItem("openFactorAuthent2", JSON.stringify(val));
        }
    }
}